import { fetchWithAuth } from './fetchWithAuth';

const BASE_URL = process.env.REACT_APP_API_URL || '/api';

// 인증 불필요 — fetchWithAuth 대상 아님
export const requestJoin = async (form) => {
  const res = await fetch(`${BASE_URL}/join/request`, {
    method : 'POST',
    headers: { 'Content-Type': 'application/json' },
    body   : JSON.stringify(form)
  });
  return await res.json();
};

// 관리자용 — 인증 필요, fetchWithAuth 적용
export const fetchJoinList = async (status) => {
  const params = status ? `?status=${status}` : '';
  return fetchWithAuth(`/join${params}`);
};

export const approveJoin = async (req_no) => {
  return fetchWithAuth(`/join/${req_no}/approve`, { method: 'POST' });
};

export const rejectJoin = async (req_no, reject_reason) => {
  return fetchWithAuth(`/join/${req_no}/reject`, {
    method: 'POST', body: JSON.stringify({ reject_reason }),
  });
};